import { Box, Flex } from '@chakra-ui/react';
import AppNavigator from 'components/AppNavigator';
import { Outlet } from 'react-router-dom';

export default function LayoutMain() {
  return (
    <Flex 
      w="full" 
      minH="100vh"
    >
      <AppNavigator />
      <Box 
        flex={1} 
        w="full"
        pl={{ lg: '252px' }}
      >
        <Outlet />
      </Box>
    </Flex>
  )
}
